import { isPlainObject } from 'lodash';
import { equals } from 'lodash/fp';

const assertNotNull = (obj: any, message: string) => {
  if (obj == null) {
    throw new Error(message);
  }
};

const toIgnore = [
  /\.runModules\[\d+\]\.isExecuted$/, // Ignores runModule[X].isExecuted
  /\.runModules\[\d+\]\.id$/, // Ignores IDs in runmodules as the backend will ignore them anyway.
  /\.runModules\[\d+\]\.type$/,
  /\.runModules\[\d+\]\.next$/,

  /\.runModules\[\d+\]\.pluginName$/,
  /\.runModules\[\d+\]\.name$/,
  /\.runModules\[\d+\]\.pluginLogo$/,
  /\.runModules\[\d+\]\.pluginId$/,
  /\.runModules\[\d+\]\.isDeprecated$/,
  /\.runModules\[\d+\]\.ModuleID$/,
];

const shouldIgnore = (namespace: string) => {
  return toIgnore.find(regex => namespace.match(regex));
};

const assertDeepEqual = (
  namespace1: string,
  obj1: any,
  namespace2: string,
  obj2: any
) => {
  if (shouldIgnore(namespace1)) {
    return;
  }

  if (obj1 === obj2) {
    return true;
  }

  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    if (obj1.length != obj2.length) {
      throw new Error(
        `${namespace1} is not equal to ${namespace2}. Arrays of different length: [${obj1.length}] != [${obj2.length}]`
      );
    }
    obj1.forEach((_, i) =>
      assertDeepEqual(
        `${namespace1}[${i}]`,
        obj1[i],
        `${namespace2}[${i}]`,
        obj2[i]
      )
    );
  } else if (isPlainObject(obj1) && isPlainObject(obj2)) {
    assertNotNull(obj1, `${namespace1} is null or undefined`);
    assertNotNull(obj2, `${namespace2} is null or undefined`);

    const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

    keys.forEach(key => {
      assertDeepEqual(
        `${namespace1}.${key}`,
        obj1[key],
        `${namespace2}.${key}`,
        obj2[key]
      );
    });
  } else if (!equals(obj1, obj2)) {
    throw new Error(
      `${namespace1} is not equal to ${namespace2}. ${obj1} != ${obj2}`
    );
  }
};

export const assertTransitMapsAreEqual = (
  transitMap1: any,
  transitMap2: any
) => {
  assertDeepEqual('TM1', transitMap1, 'TM2', transitMap2);
};
